// Client-side title/meta update ต่อ route (สำหรับ nav ในแอป — edge จัดการตอนโหลดแรก)
const BRAND = 'Barebones Thailand';

function setMeta(sel, attr, val) {
  let el = document.head.querySelector(sel);
  if (!el) { el = document.createElement('meta'); const [k, v] = attr; el.setAttribute(k, v); document.head.appendChild(el); }
  el.setAttribute('content', val);
}

export function setPageMeta({ title, description }) {
  if (title) document.title = title;
  if (description) {
    setMeta('meta[name="description"]', ['name', 'description'], description);
    setMeta('meta[property="og:description"]', ['property', 'og:description'], description);
  }
  if (title) setMeta('meta[property="og:title"]', ['property', 'og:title'], title);
}

export function titleFor(path, store) {
  const seg = path.split('/').filter(Boolean);
  if (!seg.length) return { title: `${BRAND} — Beautiful. Durable. Essential.` };
  if (seg[0] === 'c') {
    const L = { 'power-light': 'Power & Light', tools: 'Tools', 'cook-dine': 'Cook & Dine', 'store-carry': 'Store & Carry', all: 'สินค้าทั้งหมด' }[seg[1]] || 'สินค้าทั้งหมด';
    return { title: `${L} | ${BRAND}` };
  }
  if (seg[0] === 'p') {
    const p = store?.products?.find((x) => x.seo_slug === seg[1] || x.id === seg[1] || x.sku === seg[1]);
    if (p) return { title: `${p.name}${p.price != null ? ` — ฿${Number(p.price).toLocaleString('th-TH')}` : ''} | ${BRAND}`, description: p.blurb };
  }
  if (seg[0] === 'checkout') return { title: `ชำระเงิน | ${BRAND}` };
  if (seg[0] === 'track') return { title: `ตรวจสอบคำสั่งซื้อ | ${BRAND}` };
  if (seg[0] === 'help') {
    const L = { 'shipping-returns': 'การจัดส่ง & คืนสินค้า', payment: 'วิธีชำระเงิน', 'how-to-order': 'วิธีสั่งซื้อ & ติดตามพัสดุ', faq: 'คำถามที่พบบ่อย' }[seg[1]];
    if (L) return { title: `${L} | ${BRAND}` };
  }
  return { title: BRAND };
}
